(ns dashboard.services.http-config
  "Default HTTP API call parameters"
  (:require [re-frame.core :as rf]
            [ajax.core :as ajax]
            [io.repliance.util.transit :as transit]))

(def timeout
  "Default timeout for HTTP calls"
  30000)

(def transit-response-format
  (ajax/transit-response-format {:handlers transit/read-handlers}))

(def transit-request-format
  (ajax/transit-request-format))

(def defaults
  {:timeout timeout
   :format transit-request-format
   :response-format transit-response-format})

(rf/reg-event-fx
  ::request
  (fn [_ args]
    {:http-xhrio args}))
